import React, { useEffect, useState, lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify"
import 'react-toastify/dist/ReactToastify.css'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import { createSelector } from "reselect";

import { currentUser, currentAdmin } from "./functions/auth.js";
// import { auth } from "./firebase.js";
// import { supabase } from "./supabaseClient";
import { useDispatch, useSelector } from 'react-redux';
import { LoadingOutlined } from "@ant-design/icons";
import { notification } from "antd";
// import Announcement from "./components/nav/Announcement.js";
// import Home from "./pages/Home.js"
// import Header from "./components/nav/Header.js";
// import Footer from "./components/nav/Footer.js";
// import Register from "./pages/auth/Register.js";
// import RegisterComplete from "./pages/auth/RegisterComplete.js";
// import Login from "./pages/auth/Login.js";
// import ForgotPassword from "./pages/auth/ForgotPassword.js";
// import ForgotPasswordComplete from "./pages/auth/ForgotPasswordComplete.js";
// import AdminDashboard from "./pages/admin/AdminDashboard.js";
// import LoadingToRedirect from "./components/routes/LoadingToRedirect.js";
// import CategoryCreate from "./pages/admin/category/CategoryCreate.js";
// import CategoryUpdate from "./pages/admin/category/CategoryUpdate.js";
// import SubCreate from "./pages/admin/sub/SubCreate.js";
// import SubUpdate from "./pages/admin/sub/SubUpdate.js";
// import ProductCreate from "./pages/admin/product/ProductCreate.js";
// import AllProducts from "./pages/admin/product/AllProducts.js";
// import ProductUpdate from "./pages/admin/product/ProductUpdate.js";
// import Product from "./pages/Product.js";
// import CategoryHome from "./pages/category/CategoryHome.js";
// import SubHome from "./pages/sub/SubHome.js";
// import Shop from "./pages/Shop.js";
// import Cart from "./pages/Cart.js";
// import SideDrawer from "./components/drawer/SideDrawer.js";
// import Checkout from "./pages/Checkout.js";
// import CreateCouponPage from "./pages/admin/coupon/CreateCouponPage.js";
// import History from "./pages/user/History.js";
// import Password from "./pages/user/Password.js";
// import AdminPassword from "./pages/admin/AdminPassword.js";
// import Wishlist from "./pages/user/Wishlist.js";
// import AdminOrders from "./pages/admin/AdminOrders.js";
// import UsersManager from "./pages/admin/users/UsersManager.js";
// import UserDetails from "./pages/admin/users/UserDetails.js";
// import AdminNotes from "./pages/admin/AdminNotes.js";
// import AdminReviewsReply from "./pages/admin/AdminReviewsReply.js";
// import FrequentlyQuestions from "./pages/FrequentlyQuestions.js";
// import DiscountedProducts from "./pages/DiscountedProducts.js";


// lazy - imports
const Login = lazy(() => import("./pages/auth/Login.js"))
const Register = lazy(() => import("./pages/auth/Register.js"))
const RegisterComplete = lazy(() => import("./pages/auth/RegisterComplete.js"))
const Home = lazy(() => import("./pages/Home.js"));
const Footer = lazy(() => import("./components/nav/Footer.js"))
const ForgotPasswordComplete = lazy(() => import("./pages/auth/ForgotPasswordComplete.js"))
const AdminPassword = lazy(() => import("./pages/admin/AdminPassword.js"))
const AdminOrders = lazy(() => import("./pages/admin/AdminOrders.js"))
const Announcement = lazy(() => import("./components/nav/Announcement.js"));
const Header = lazy(() => import("./components/nav/Header.js"))
const ForgotPassword = lazy(() => import("./pages/auth/ForgotPassword.js"))
const History = lazy(() => import("./pages/user/History.js"))
const Password = lazy(() => import("./pages/user/Password.js"))
const Wishlist = lazy(() => import("./pages/user/Wishlist.js"))
const AdminDashboard = lazy(() => import("./pages/admin/AdminDashboard.js"))
const CategoryCreate = lazy(() => import("./pages/admin/category/CategoryCreate.js"))
const CategoryUpdate = lazy(() => import("./pages/admin/category/CategoryUpdate.js"))
const SubCreate = lazy(() => import("./pages/admin/sub/SubCreate.js"))
const SubUpdate = lazy(() => import("./pages/admin/sub/SubUpdate.js"))
const ProductCreate = lazy(() => import("./pages/admin/product/ProductCreate.js"))
const AllProducts = lazy(() => import("./pages/admin/product/AllProducts.js"))
const Product = lazy(() => import("./pages/Product.js"))
const CategoryHome = lazy(() => import("./pages/category/CategoryHome.js"))
const SubHome = lazy(() => import("./pages/sub/SubHome.js"))
const Shop = lazy(() => import("./pages/Shop.js"))
const Cart = lazy(() => import("./pages/Cart.js"))
const SideDrawer = lazy(() => import("./components/drawer/SideDrawer.js"))
const Checkout = lazy(() => import("./pages/Checkout.js"))
const CreateCouponPage = lazy(() => import("./pages/admin/coupon/CreateCouponPage.js"))
// const Payment = lazy(() => import("./pages/Payment.js"))
const ProductUpdate = lazy(() => import("./pages/admin/product/ProductUpdate.js"))
const LoadingToRedirect = lazy(() => import("./components/routes/LoadingToRedirect.js"))
const UsersManager = lazy(() => import("./pages/admin/users/UsersManager.js"))
const UserDetails = lazy(() => import("./pages/admin/users/UserDetails.js"))
const AdminNotes = lazy(() => import("./pages/admin/AdminNotes.js"))
const AdminReviewsReply = lazy(() => import("./pages/admin/AdminReviewsReply.js"))
const FrequentlyQuestions = lazy(() => import("./pages/FrequentlyQuestions.js"))
const DiscountedProducts = lazy(() => import("./pages/DiscountedProducts.js"))
const ProductsQuantity = lazy(() => import("./pages/admin/product/ProductsQuantity.js"))


function App() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminChecked, setAdminChecked] = useState(false);

  let dispatch = useDispatch();


  //redux
  const selectUser = (state) => state.user;

  const selectUserAndCart = createSelector(
    [selectUser],
    (user) => ({ user }) // Derived state
  );

  const { user } = useSelector(selectUserAndCart);
  //redux


  //to check firebase auth state

  // useEffect(() => {
  //   let unsubscribe = auth.onAuthStateChanged(async (user) => {
  //     // console.log("user in App.js : ",user)
  //     if (user) {
  //       const idTokenResult = await user.getIdTokenResult();

  //       currentUser(idTokenResult.token)
  //         .then((res) => {
  //           // console.log("create or update user ", res);

  //           dispatch({
  //             type: "LOGGED_IN_USER",
  //             payload: {
  //               name: res.data.name,
  //               email: res.data.email,
  //               mobile: res.data.mobile,
  //               token: idTokenResult.token,
  //               role: res.data.role,
  //               id: res.data.id
  //             },
  //           });
  //         })
  //         .catch((err) => console.log(err));
  //     }
  //   });
  //   // cleanup
  //   return () => unsubscribe();
  // }, [dispatch]);

  useEffect(() => {

    async function getUserDetail() {


      try {
        const token = localStorage.getItem("token");
        // if (user && user.token) {
        //   const res = await currentUser(user.token)

        //   console.log("res.data in app.js", res.data);

        if (token) {
          const res = await currentUser(token)

          // console.log(JSON.stringify(res.data));
          

          dispatch({
            type: "LOGGED_IN_USER",
            payload: {
              name: res.data.name,
              email: res.data.email,
              mobile: res.data.mobile,
              token: res.data.token,
              role: res.data.role,
              id: res.data.id
            },
          });
        }
      } catch (error) {
        localStorage.removeItem("token");
        console.error("🔥 Auth error:", error);
        if (error.code === "auth/network-request-failed") {
          // alert("ارتباط با سرور Firebase برقرار نشد. لطفاً اینترنت خود را بررسی کنید.");
          notification.warning({
            message: "ارتباط با سرور برقرار نشد. لطفاً اینترنت خود را بررسی کنید.",
            showProgress: true,
            style: {
              fontSize: '16px',
              fontFamily: "Vazir",
              direction: "rtl",
            },
          });
        }
      }
    }
    getUserDetail();


    // const idTokenResult = await user.getIdTokenResult();


  }, [dispatch]);

  //   useEffect(() => {
  //   const { data: { subscription } } = supabase.auth.onAuthStateChange(
  //     async (event, session) => {
  //       // فقط زمانی که سشن وجود دارد و رویداد مناسب است اقدام کن
  //       if (session && (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED')) {
  //         try {
  //           const res = await currentUser(session.access_token);

  //           dispatch({
  //             type: "LOGGED_IN_USER",
  //             payload: {
  //               ...res.data,
  //               token: session.access_token, // توکن جدید را جایگزین کن
  //             },
  //           });
  //         } catch (err) {
  //           console.error("خطا در همگام‌سازی کاربر:", err);
  //         }
  //       }

  //       if (event === 'SIGNED_OUT') {
  //         dispatch({ type: "LOGOUT", payload: null });
  //       }
  //     }
  //   );

  //   return () => subscription.unsubscribe();
  // }, [dispatch]);


  // useEffect(() => {
  //   const unsubscribe = auth.onAuthStateChanged(async (user) => {
  //     if (user) {
  //       try {
  //         const idTokenResult = await user.getIdTokenResult();

  //         const res = await currentUser(idTokenResult.token);

  //         dispatch({
  //           type: "LOGGED_IN_USER",
  //           payload: {
  //             name: res.data.name,
  //             email: res.data.email,
  //             mobile: res.data.mobile,
  //             token: idTokenResult.token,
  //             role: res.data.role,
  //             id: res.data.id
  //           },
  //         });
  //       } catch (error) {
  //         console.error("🔥 Auth error:", error);
  //         if (error.code === "auth/network-request-failed") {
  //           // alert("ارتباط با سرور Firebase برقرار نشد. لطفاً اینترنت خود را بررسی کنید.");
  //           notification.warning({
  //                   message: "ارتباط با سرور برقرار نشد. لطفاً اینترنت خود را بررسی کنید.",
  //                   showProgress: true,
  //                   style: {
  //                       fontSize: '16px',
  //                       fontFamily: "Vazir",
  //                       direction: "rtl",
  //                   },
  //               });
  //         }
  //       }
  //     }
  //   });
  //   return () => unsubscribe();
  // }, [dispatch]);

  // function AdminCheckRoute() {
  //   // const {user} = useSelector((state) => ({...state}));
  //   const [ok, setOk] = useState(false);


  //   useEffect(() => {
  //     if (user && user.token) {
  //       currentAdmin(user.token)
  //         .then(res => {
  //           console.log("current Admin res", res);
  //           if(res.data.error === "Admin resurce. Access denied."){
  //             setOk(false);
  //             return 
  //           }
  //           // console.log(user);

  //           setOk(true);
  //         })
  //         .catch(err => {
  //           console.log("Admin Route error", err);
  //           setOk(false);
  //         })
  //     }
  //     // }, []);
  //   }, [user]);   // i changed and delete user in [ ] above


  //   // console.log(ok);

  //   return (ok);
  // };
  // console.log(AdminCheckRoute());

  useEffect(() => {
    // console.log("user", user);
    // console.log("user token", localStorage.getItem("token"));
    const token = localStorage.getItem("token");
    const checkAdmin = async () => {
      try {


        if (token) {
          try {
            const res = await currentAdmin(token);
            // console.log("res.data", res.data);

            if (res.data && !res.data.error) {
              setIsAdmin(true);
              // console.log("admin checked");
            }
          } catch (err) {
            setIsAdmin(false);
            // console.log("NOT admin");
          } finally {
            setAdminChecked(true); // صرف‌نظر از موفق یا ناموفق بودن، بررسی کامل شده
          }
        } else {
          setAdminChecked(true); // کاربر لاگین نیست ولی بررسی تکمیل شده
          // console.log("admin NOT checked");
        }


      } catch (error) {
        notification.warning({
          message: "ارتباط با سرور برقرار نشد. لطفاً اینترنت خود را بررسی کنید.",
          showProgress: true,
          style: {
            fontSize: '16px',
            fontFamily: "Vazir",
            direction: "rtl",
          },
        });
      }
    };

    checkAdmin();




  }, [user]);

  function AdminCheckRoute() {
    if (!adminChecked) return false; // یا نمایش لودر
    return isAdmin ? true : false;
  }

  return (
    <Suspense fallback={
      <div className="col text-center p-5 fs-2 " style={{ color: "darkred" }}>
        __ SABA<LoadingOutlined className="" />NUT __
      </div>
    }>
      <Announcement />
      <Header />
      <SideDrawer />
      <ToastContainer />

      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/register" element={<Register />} />
        <Route exact path="/register/complete" element={<RegisterComplete />} />
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/forgot/password" element={<ForgotPassword />} />
        <Route exact path="/forgot/password/complete" element={<ForgotPasswordComplete />} />
        <Route path="/user/history" element={user && user.token ? <History /> : <LoadingToRedirect />} />
        <Route path="/user/password" element={user && user.token ? <Password /> : <LoadingToRedirect />} />
        <Route path="/user/wishlist" element={user && user.token ? <Wishlist /> : <LoadingToRedirect />} />

        <Route path="/discounted-products" element={<DiscountedProducts />} />
        <Route path="/frequently-questions" element={<FrequentlyQuestions />} />
        <Route path="/admin/reply" element={AdminCheckRoute() ? <AdminReviewsReply /> : <LoadingToRedirect />} />
        <Route path="/admin/notes" element={AdminCheckRoute() ? <AdminNotes /> : <LoadingToRedirect />} />
        <Route path="/admin/user/:userId" element={AdminCheckRoute() ? <UserDetails /> : <LoadingToRedirect />} />
        <Route path="/admin/users" element={AdminCheckRoute() ? <UsersManager /> : <LoadingToRedirect />} />
        <Route path="/admin/orders" element={AdminCheckRoute() ? <AdminOrders /> : <LoadingToRedirect />} />
        <Route path="/admin/password" element={AdminCheckRoute() ? <AdminPassword /> : <LoadingToRedirect />} />
        <Route path="/admin/dashboard" element={AdminCheckRoute() ? <AdminDashboard /> : <LoadingToRedirect />} />
        <Route path="/admin/category" element={AdminCheckRoute() ? <CategoryCreate /> : <LoadingToRedirect />} />
        <Route path="/admin/category/:slug" element={AdminCheckRoute() ? <CategoryUpdate /> : <LoadingToRedirect />} />
        <Route path="/admin/sub" element={AdminCheckRoute() ? <SubCreate /> : <LoadingToRedirect />} />
        <Route path="/admin/sub/:slug" element={AdminCheckRoute() ? <SubUpdate /> : <LoadingToRedirect />} />
        <Route path="/admin/product" element={AdminCheckRoute() ? <ProductCreate /> : <LoadingToRedirect />} />
        <Route path="/admin/products" element={AdminCheckRoute() ? <AllProducts /> : <LoadingToRedirect />} />
        <Route path="/admin/products-quantity" element={AdminCheckRoute() ? <ProductsQuantity /> : <LoadingToRedirect />} />
        <Route path="/admin/product/:slug" element={AdminCheckRoute() ? <ProductUpdate /> : <LoadingToRedirect />} />
        <Route exact path="/product/:slug" element={<Product />} />
        <Route exact path="/category/:slug" element={<CategoryHome />} />
        <Route exact path="/sub/:slug" element={<SubHome />} />
        <Route exact path="/shop" element={<Shop />} />
        <Route exact path="/cart" element={<Cart />} />
        <Route path="/checkout" element={user && user.token ? <Checkout /> : <LoadingToRedirect />} />
        <Route path="/admin/coupon" element={AdminCheckRoute() ? <CreateCouponPage /> : <LoadingToRedirect />} />





      </Routes>
      <Footer />
    </Suspense>

  );
}

export default App;

// sabz:  #2e533b
// zereshki:  darkred       #8a0000
// kerem:  antiquewhite     #faead7
// talaii:  #fda334
